import React, { useEffect } from "react";
import type { AdPositionEnum } from "../../../client/api";
import { InternalAdRenderer } from "../InternalAdRenderer";
import { trackAmplitude } from "../../../config/amplitude";
import AdSenseAd from "../AdSenseAd";
import { ADSENSE_CONFIG, AdSensePositionEnum } from "../../../config/adsenseConfig";
import { WebAdSlot } from "../WebAdSlot";
import { useAdSelection } from "../../../hooks/useAdSelection";

type AdSlotProps = {
  type: AdPositionEnum | AdSensePositionEnum;
  className?: string;
  priority?: "internal" | "adsense" | "auto";
};

export function AdSlot({
                         type,
                         className,
                         priority = "auto"
                       }: AdSlotProps) {
  const hasAdSenseConfig = Boolean(ADSENSE_CONFIG[type]);
  const skipSelection = priority === "adsense" || priority === "internal" || type === AdSensePositionEnum.MATCH_RIGHT_RAIL || type === AdSensePositionEnum.PLAYER_RIGHT_RAIL || type === AdSensePositionEnum.TEAM_RIGHT_RAIL;

  const { selectedAd, pro } = useAdSelection({
    type,
    canShowAdSense: hasAdSenseConfig,
    skipSelection
  });

  useEffect(() => {
    if (selectedAd && !pro) {
      trackAmplitude("ad_view", { type, name: selectedAd.name });
    }
  }, [selectedAd, pro, type]);

  if (pro) {
    return null;
  }

  if (priority === "adsense" && hasAdSenseConfig) {
    return <AdSenseAd position={type} className={className} />;
  }

  if (priority === "internal") {
    return <WebAdSlot type={type} className={className} />;
  }

  if (priority === "auto") {
    if (selectedAd && selectedAd.imageDesktop) {
      return (
        <InternalAdRenderer
          ad={selectedAd}
          position={selectedAd.position}
          className={className}
        />
      );
    }

    if (hasAdSenseConfig) {
      return <AdSenseAd position={type} className={className} />;
    }

    return <WebAdSlot type={type} className={className} />;
  }

  return <WebAdSlot type={type} className={className} />;
}

